import './AdBlockerNotification.less';
import { Dialog } from '@adtech/ui';
import { checkAdBlock } from '@hydra/top100-components/helpers';
import { IconAdBlockerNotification } from '@images/svg/icon-adBlocker-notification';
import { sendEvent } from '@utils/top100Counter';
import React, { useState, useEffect } from 'react';

const AdBlockerNotification: React.FC = () => {
    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        const check = async () => {
            const hasAdblock = await checkAdBlock();
            sendEvent('adblock', { status: hasAdblock ? 'yes' : 'no' });
            if (hasAdblock && !sessionStorage.getItem('userNotifiedByAdBlock')) setIsOpened(true);
        };

        check();
    }, []);

    const handleClose = () => {
        setIsOpened(false);
        sessionStorage.setItem('userNotifiedByAdBlock', 'true');
    };

    return (
        <Dialog
            title={
                <span className="a-Notification__header">
                    <IconAdBlockerNotification />У вас включен блокировщик рекламы
                </span>
            }
            size="lg"
            isOpened={isOpened}
            className="a-Notification"
            onClose={handleClose}
            onCancel={() => {}}
            cancelText="Все равно продолжить"
            closeOnClickOutside={false}
        >
            <div className="inner">
                <p>Некоторые функции платформы могут быть недоступны из-за включенных блокировщиков рекламы.</p>
                <p>Чтобы продолжить пользоваться SberAds, отключите блокировщик и&nbsp;перезагрузите страницу.</p>
            </div>
        </Dialog>
    );
};

export default AdBlockerNotification;
